module.exports = __webpack_public_path__ + "img/22.4613d8a5.jpg";